import CommandHandler from 'diagram-js/lib/command/CommandHandler';
import {Base} from 'diagram-js/lib/model';
import {PathwaysModeling} from '@ispm-client/modules/bpmn-modeler/bpmn/commands/pathways-modeling';
import {ModelingUtil} from '@ispm/shared/bpmn-io/modeling-util';
import {BpmnExtensionHelper} from '@ispm/shared/bpmn-io/bpmn-extension-helper';
import {NodeType} from '@ispm/shared/bpmn-io/node-type';

export class NodeClearDataHandler implements CommandHandler {


  constructor(private modeling, private pathwaysModeling: PathwaysModeling, private bpmnExtensionHelper: BpmnExtensionHelper) {
  }

  preExecute(context) {
    const element = context.element;
    const nodeDetails = ModelingUtil.getNodeDetails(element);
    if (nodeDetails.nodeType !== NodeType.treatment) {
      const connections = ModelingUtil.getNodeIncomingConnections(element);
      if (connections && connections.length > 0) {
        this.pathwaysModeling.clearConnectionConditionExpression(connections[0]);
      }
    }
  }

  postExecute(context): Base[] {
    const element = context.element;
    const nodeDetails = ModelingUtil.getNodeDetails(element);
    if (nodeDetails) {
      delete nodeDetails.complicated;
      delete nodeDetails.fields;
      this.bpmnExtensionHelper.replaceExtension(element, nodeDetails);
    }
    const guideBox = ModelingUtil.getGuideBox(element);
    if (guideBox) {
      delete guideBox.automatically;
      this.bpmnExtensionHelper.replaceExtension(element, guideBox);
    }
    return [element];
  }


}
